/**
 * File: src/components/admin-game-selector.js
 * Mô tả: Component thanh chọn tựa game trong trang Admin để nạp dữ liệu cấu hình tương ứng.
 * Liên quan: src/data/games.js, src/pages/admin-page.js
 */

import { createElement } from '../utils/dom.js';
import { games } from '../data/games.js';

/**
 * Render thanh chọn game
 * @param {string} selectedGameId 
 * @param {Function} onSelectGame 
 * @returns {HTMLElement}
 */
export const renderAdminGameSelector = (selectedGameId, onSelectGame) => {
  const container = createElement('div', {
    className: 'admin-game-selector',
    attributes: { style: 'background: var(--bg-secondary); padding: 1.25rem; border-radius: var(--radius-lg); border: var(--border-glass); margin-bottom: 2rem;' },
  });

  const cardsHtml = games
    .filter((game) => game.supportsRemoteConfig !== false)
    .map((g) => {
      const isSelected = g.id === selectedGameId;
      return `
        <div class="game-select-card" data-id="${g.id}" style="padding: 1rem; border-radius: var(--radius-md); border: ${
        isSelected ? '2px solid var(--color-accent)' : 'var(--border-glass)'
      }; background: ${isSelected ? 'var(--bg-tertiary)' : 'var(--bg-primary)'}; cursor: pointer; transition: all var(--transition-fast); display: flex; align-items: center; gap: 0.75rem;">
          <img src="${g.coverImage}" alt="${g.title}" style="width: 44px; height: 44px; object-fit: cover; border-radius: 6px;" />
          <div>
            <div style="font-weight: 700; font-size: 0.95rem; color: ${isSelected ? 'var(--color-accent)' : 'var(--color-text-main)'};">${g.title}</div>
            <div style="font-size: 0.75rem; color: var(--color-text-dim);">${g.genre} ${isSelected ? '• [Đang Chọn]' : ''}</div>
          </div>
        </div>
      `;
    })
    .join('');

  container.innerHTML = `
    <h4 style="margin-bottom: 0.75rem; color: var(--color-text-main);">🎯 Chọn Tựa Game Để Quản Trị Cấu Hình:</h4>
    <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 1rem;">
      ${cardsHtml}
    </div>
  `;

  container.querySelectorAll('.game-select-card').forEach((card) => {
    card.addEventListener('click', () => {
      const gameId = card.getAttribute('data-id');
      if (onSelectGame) onSelectGame(gameId);
    });
  });

  return container;
};
